import { createFocusTrap } from 'focus-trap';
import { module } from 'modujs';
import { html } from '../utils/environment';

const CLASS = {
    OPEN: 'has-search-open',
}

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                closeButton: 'close',
                overlay: 'close'
            }
        }
    }

    init() {
        this.closeBind = (e) => {
            if (e.key === 'Escape') {
                this.close();
            }
        }

        document.addEventListener('keyup', this.closeBind);

        this.focusTrap = createFocusTrap([this.el], {
            checkCanFocusTrap: (trapContainers) => {
                const results = trapContainers.map((trapContainer) => {
                    return new Promise((resolve) => {
                        const interval = setInterval(() => {
                            if (getComputedStyle(trapContainer).visibility !== 'hidden') {
                                resolve();
                                clearInterval(interval);
                            }
                        }, 5);
                    });
                });

                return Promise.all(results);
            },
            allowOutsideClick: true,
        });
    }

    open() {
        html.classList.add(CLASS.OPEN);
        this.focusTrap?.activate();
    }

    close() {
        html.classList.remove(CLASS.OPEN);
        this.focusTrap?.deactivate();
    }

    destroy() {
        this.focusTrap?.deactivate({ returnFocus: false });
        document.removeEventListener('keyup', this.closeBind);
    }
}
